import React from "react"
import Tippy from "@tippy.js/react"
import "tippy.js/dist/tippy.css"
import * as Icon from "react-feather"

const SharePost = ({ data }) => {
  // console.log("share post", data)
  return (
    <div className="share-post">
      <ul className="social-links mb-4">
        <li>
          <Tippy content="Share on facebook">
            <a
              target="_blank"
              href={`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftarkashilpa.com%2F${data}`}
              className="facebook-share-button"
              data-title="Share on facebook"
            >
              <Icon.Facebook />
            </a>
          </Tippy>
        </li>
        <li>
          <Tippy content="Share on Twitter">
            <a
              className="twitter-share-button"
              target="_blank"
              href={`https://twitter.com/intent/tweet?url=https://tarkashilpa.com/${data}`}
              data-size="large"
              data-title="Share on Twitter"
            >
              <Icon.Twitter />
            </a>
          </Tippy>
        </li>
        <li>
          <Tippy content="Share on Linkedin">
            <a
              className="linkedin-share-button"
              href={`https://www.linkedin.com/sharing/share-offsite/?url=https://tarkashilpa.com/${data}`}
              target="_blank"
              data-title="Share on Linkedin"
            >
              <Icon.Linkedin />
            </a>
          </Tippy>
        </li>
        <li>
          <Tippy content="Copy Link">
            <a
              className="copylink-share-button"
              onClick={() =>
                navigator.clipboard.writeText(`https://tarkashilpa.com/${data}`)
              }
              data-title="Copy Link"
            >
              <Icon.Link />
            </a>
          </Tippy>
        </li>
      </ul>
    </div>
  )
}

export default SharePost
